import { render, staticRenderFns } from "./HostStrainDetail.vue?vue&type=template&id=34491f1c&scoped=true"
import script from "./HostStrainDetail.vue?vue&type=script&lang=js"
export * from "./HostStrainDetail.vue?vue&type=script&lang=js"
import style0 from "./HostStrainDetail.vue?vue&type=style&index=0&id=34491f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34491f1c",
  null
  
)

export default component.exports